import ExpressionLanguageService from './ExpressionLanguageService';

export default angular.module('edge.platform.el', [])
    .factory('ExpressionLanguageService', ExpressionLanguageService);
